RivalIQ.apps.Share.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyTile = Marionette.ItemView.extend({
        className: 'col-md-4',
        template: '#shareCompanyTileTemplate'
    });

    views.LandscapeCompanyTiles = Marionette.CollectionView.extend({
        childView: views.CompanyTile
    });
});
